import { combineReducers } from 'redux';
import { reduxPollingNamespace, reduxPollingReducer } from 'redux-polling';

import { baseAPI } from 'redux/slices/baseApi';
import { billingApi } from 'redux/slices/billingApi';
import { generalSlice } from 'redux/slices/general';
import { homeSlice } from 'redux/slices/home';
import { integrationSlice } from 'redux/slices/integration';
import loadingStatesReducer from 'redux/slices/loadingStates';
import { loginApi } from 'redux/slices/loginApi';
import { onBoardingAPI } from 'redux/slices/onBoardingApi';
import { registerSlice } from 'redux/slices/register';
import { settingsSlice } from 'redux/slices/settings';
import { settingsApi } from 'redux/slices/settingsApi';
import { themesSlice } from 'redux/slices/themes';
import { userProfileSlice } from 'redux/slices/userProfile';
import { userProfileAPI } from 'redux/slices/userProfileApi';
import usersUi from 'redux/slices/users';
import { workflowSlice } from 'redux/slices/workflow';
import { workflowApi } from 'redux/slices/workflowApi';

import { globalAPI } from '../slices/globalApi';
import pollApi from '../slices/polling';
import apiCall from './apiCall';
import auth from './auth';
import billing from './billing';
import eep from './eep';
import integration from './integration';
import loader from './loader';
import search from './search';
import tcm from './tcm';
import toaster from './toaster';
import users from './users';

const reducer = combineReducers({
    [reduxPollingNamespace]: reduxPollingReducer,
    auth,
    apiCall,
    integration,
    toaster,
    loader,
    billing,
    search,
    pollApi,
    tcm,
    [baseAPI.reducerPath]: baseAPI.reducer,
    [billingApi.reducerPath]: billingApi.reducer,
    [globalAPI.reducerPath]: globalAPI.reducer,
    users,
    usersUi,
    eep,
    integrationV2: integrationSlice.reducer,
    general: generalSlice.reducer,
    home: homeSlice.reducer,
    companyRegistrationData: registerSlice.reducer,
    [onBoardingAPI.reducerPath]: onBoardingAPI.reducer,
    [loginApi.reducerPath]: loginApi.reducer,
    [userProfileAPI.reducerPath]: userProfileAPI.reducer,
    workflowV2: workflowSlice.reducer,
    [workflowApi.reducerPath]: workflowApi.reducer,
    settingsV2: settingsSlice.reducer,
    [settingsApi.reducerPath]: settingsApi.reducer,
    theme: themesSlice.reducer,
    userProfile: userProfileSlice.reducer,
    loadingStates: loadingStatesReducer,
});

export default reducer;
